$(document).on('turbolinks:load', () => {
  $('.promo-toggle').on("click", e => {
    e.preventDefault()
    e.target.classList.add('d-none')
  })
})
